// extracted by mini-css-extract-plugin
module.exports = {"form":"form--oYy6b","messageContent":"messageContent--vb6Mt","success":"success--rN-eV","error":"error--Gs8Hp","text":"text--XDOXi","groupCheckbox":"groupCheckbox--YeEgd"};